<template>
  <AppDropdown
    v-tooltip="'Compartilhar'"
    :items="items"
    v-bind="dropdownSettings_"
    @select="share"
  />
</template>
<script>
import AppDropdown from '../AppDropdown'

const DROPDOWN_SETTINGS = {
  popover: { title: 'Compartilhar', closeButtonVisible: true },
  target: { icon: '@escavador/share', iconSize: 20 },
}
/**
 * AppCompartilhar é um Wrapper para AppDropdown
 * configurado para ser um série de opções de compartilhamento para uma dada url.
 *
 * Sendo assim, você pode passar as mesmas props úteis em AppDropdown.
 *
 * @depends plugins/navigator
 * @depends plugins/clipboard
 */
export default {
  name: 'AppCompartilhar',
  components: {
    AppDropdown,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    dropdownSettings: {
      type: Object,
      default: () => DROPDOWN_SETTINGS,
    },
  },
  computed: {
    items() {
      return [
        {
          icon: '@escavador/social-whatsapp-circle',
          iconType: 'baseline',
          label: 'Whatsapp',
          value: 'whatsapp',
        },
        {
          icon: '@escavador/social-facebook-circle',
          iconType: 'baseline',
          label: 'Facebook',
          value: 'facebook',
        },
        {
          icon: '@escavador/social-twitter-circle',
          iconType: 'baseline',
          label: 'Twitter',
          value: 'twitter',
        },
        {
          icon: '@escavador/link',
          iconType: 'outline',
          label: 'Copiar link',
          value: 'copy',
        },
      ]
    },
    dropdownSettings_() {
      return {
        ...this.$attrs,
        ...DROPDOWN_SETTINGS,
        ...this.dropdownSettings,
      }
    },
    uri() {
      return this.url || this.$navigator.getCurrentUri()
    },
  },
  methods: {
    share(item) {
      this[item.value]()
    },
    copy() {
      this.$copyText(this.uri)
        .then(() => {
          this.$toast.show('Link copiado!')
        })
        .catch(() => {
          this.$toast.error('Não foi possível copiar. Tente novamente.')
        })
    },
    facebook() {
      this.$navigator.popup({
        path: 'https://www.facebook.com/sharer.php',
        params: {
          u: this.uri,
        },
      })
    },
    twitter() {
      const title = this.title.split('|').join('-')

      this.$navigator.popup({
        path: 'http://twitter.com/share',
        params: {
          text: title,
          url: this.$navigator.getCurrentUri(),
          via: 'SiteEscavador',
        },
      })
    },
    whatsapp() {
      this.$navigator.popup({
        path: 'https://api.whatsapp.com/send',
        params: {
          text: `${this.title} - ${this.uri}`,
        },
      })
    },
  },
}
</script>
